import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { ChallengeDigitalWorkingHoursEntity } from '../../entities/challenge-insights/digital-working-hours/challenge-digital-working-hours.entity';
import { MetricValueType } from '../../../../interface/dtos';
import { ChallengeTargetOperatorEnum } from '../../../../common/enum/challenge-target/challenge-target-operator.enum';

export interface ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRootProps {
  entity: ChallengeDigitalWorkingHoursEntity;
  currentDayEntity: ChallengeDigitalWorkingHoursEntity;
  targetValue: number;
  type: MetricValueType;
}

export class ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot extends Entity<ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRootProps> {
  protected _id: string;
  protected _successPercentage: number;
  protected _operator: ChallengeTargetOperatorEnum;
  static create(
    props: ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRootProps,
    entityId?: string
  ): ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot {
    const id = entityId || v4();
    const entity =
      new ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot({
        id,
        props,
      });
    return entity;
  }
  public validate(): void {}

  get type(): MetricValueType {
    return this.props.type;
  }

  get count(): number {
    return this.props.entity.count;
  }
  get todayValue(): number {
    return this.props.currentDayEntity.value;
  }
  get todayAverage(): number {
    return this.props.currentDayEntity.average;
  }
  get todayAveragePercentage(): number {
    return 100 * this.todayAverage;
  }
  get value(): number {
    return this.props.entity.value;
  }
  get average(): number {
    return this.props.entity.average;
  }
  get targetValue(): number {
    return this.props.targetValue;
  }
  get deviation(): number {
    return this.todayAverage - this.targetValue;
  }
  public setSuccessPercentage(value: number): void {
    this._successPercentage = value;
  }
  get successPercentage(): number {
    return this._successPercentage;
  }
  setChallengeTargetOperator(operator: ChallengeTargetOperatorEnum): void {
    this._operator = operator;
  }
  get projectedSuccess(): boolean {
    return this._operator === ChallengeTargetOperatorEnum.MAX
      ? this.deviation <= 0
      : this.deviation >= 0;
  }
}
